import { motion } from "framer-motion";
import React, { useContext, useState } from "react";
import { FaArrowRight, FaEnvelope } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import VisibilitySensor from "react-visibility-sensor";
import { Context } from "../../context";
import classes from "./TopHome.module.css";

const TopHome = () => {
  const { lang } = useContext(Context);
  const [isVisible, setIsVisible] = useState(false);

  const changeVisibility = (isVisibleSensor) => {
    if (isVisibleSensor && !isVisible) {
      setIsVisible(true);
    }
  };

  return (
    <section id="topHome" className={classes.sectionWrapper}>
      <div className="container">
        {/* --- HEADER DELLA SEZIONE (PRESENTAZIONE / BENVENUTO) --- */}
        <div className={classes.sectionHeader}>
          <div className={classes.devPreTitle}>
            <span className={classes.devPrompt}>$</span>
            <span className={classes.devCmd}>cat welcome.js</span>
            <span className={classes.devCursor} />
          </div>
          <h2 className={classes.mainTitle}>
            {lang === "en" ? (
              <>Welcome to my <span className={classes.highlight}>personal website</span></>
            ) : (
              <>Benvenuto sul mio <span className={classes.highlight}>sito personale</span></>
            )}
          </h2>
          <p className={classes.mainSubtitle}>
            {lang === "en"
              ? "Full Stack Web Developer & Creative Coder. Explore my journey, skills, projects, and 3D experiences."
              : "Full Stack Web Developer & Creative Coder. Esplora il mio percorso, le mie competenze, i progetti e le esperienze 3D interattive."}
          </p>
          <div className={classes.titleUnderline} />
        </div>

        {/* --- GRIGLIA DELLE CARTE --- */}
        <div className={classes.cardsGrid}>
          {/* CARD 1: davidebalice.dev (sfondo orientato a destra) */}
          <VisibilitySensor onChange={changeVisibility} partialVisibility delayedCall>
            <motion.div
              initial={{ opacity: 0, y: 25 }}
              animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 25 }}
              transition={{ duration: 0.5 }}
              className={`${classes.card} ${classes.cardMobileBg}`}
            >
              <div className={classes.cardContent}>
                <div className={classes.logoBox}>
                  <img src="/assets/images/logo.png" alt="DB Logo" className={classes.logoImg} />
                </div>
                <h3 className={classes.cardTitle}>davidebalice.dev</h3>
                <p className={classes.cardText}>
                  {lang === "en"
                    ? "My personal website, developed with React and Node.js. A hub where I share my journey, ideas and showcase my projects."
                    : "Il mio sito personale, sviluppato con React e Node.js. Un hub dove racconto il mio percorso, condivido idee e presento i miei progetti."}
                </p>
              </div>
            </motion.div>
          </VisibilitySensor>

          {/* CARD 2: Collaborations (sfondo orientato a destra) */}
          <VisibilitySensor onChange={changeVisibility} partialVisibility delayedCall>
            <motion.div
              initial={{ opacity: 0, y: 25 }}
              animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 25 }}
              transition={{ duration: 0.5, delay: 0.15 }}
              className={`${classes.card} ${classes.cardCollabBg}`}
            >
              <div className={classes.cardContent}>
                <div className={classes.collabBadge}>
                  <span className={classes.badgeDash}>—</span> COLLABORATIONS
                </div>
                <h3 className={classes.cardTitle}>Collaborations</h3>
                <p className={classes.cardText}>
                  {lang === "en"
                    ? "Projects, experiments and open source contributions. A space where I explore new technologies and collaborate with other developers."
                    : "Progetti, esperimenti e contributi open source. Uno spazio dove esploro nuove tecnologie e collaboro con altri developer."}
                </p>
              </div>
            </motion.div>
          </VisibilitySensor>

          {/* CARD 3: Lavoriamo insieme? (Full Width) */}
          <VisibilitySensor onChange={changeVisibility} partialVisibility delayedCall>
            <motion.div
              initial={{ opacity: 0, y: 25 }}
              animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 25 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className={`${classes.card} ${classes.fullWidthCard}`}
            >
              <div className={classes.fullCardContent}>
                <div className={classes.workBadge}>
                  <span className={classes.badgeDash}>—</span>
                  {lang === "en" ? "LET'S WORK TOGETHER?" : "LAVORIAMO INSIEME?"}
                </div>
                <h3 className={classes.fullCardTitle}>
                  {lang === "en" ? "Have an idea or a project to build?" : "Hai un'idea o un progetto da realizzare?"}
                </h3>
                <p className={classes.fullCardText}>
                  {lang === "en"
                    ? "I am always open to new challenges, collaborations and interesting projects."
                    : "Sono sempre aperto a nuove sfide, collaborazioni e progetti interessanti."}
                </p>
                <NavLink to="/contact" className={`${classes.btn} ${classes.btnPrimary}`}>
                  <FaEnvelope className={classes.btnIconLeft} />
                  {lang === "en" ? "Contact me" : "Contattami"} <FaArrowRight className={classes.btnIcon} />
                </NavLink>
              </div>
            </motion.div>
          </VisibilitySensor>
        </div>
      </div>
    </section>
  );
};

export default TopHome;
